import { useState, useEffect, useCallback } from 'react';
import { AdminSidebar } from './AdminDashboard';
import api from '../lib/api';
import { Star, Check, X } from '@phosphor-icons/react';

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ✅ Fonction stabilisée
  const fetchReviews = useCallback(() => {
    api.get(`/admin/reviews?page=${page}&limit=20`)
      .then(r => {
        setReviews(r.data.reviews);
        setTotalPages(r.data.pages);
      })
      .catch(() => {});
  }, [page]); // ← dépendance réelle

  // ✅ Plus d'avertissement ESLint
  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  const moderate = async (id, approved) => {
    try {
      await api.put(`/admin/reviews/${id}/moderate`, { isApproved: approved });
      fetchReviews(); // fonctionne toujours
    } catch {}
  };

  return (
    <div className="pt-20 min-h-screen" data-testid="admin-reviews-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <AdminSidebar />
          <div className="flex-1">
            <h1 className="font-heading text-3xl text-white mb-8">Moderation des avis</h1>
            <div className="space-y-3">
              {reviews.map(r => (
                <div key={r.id} className="bg-desti-surface border border-white/5 p-5" data-testid={`admin-review-${r.id}`}>
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <p className="text-sm text-white">{r.userName || 'Anonyme'}</p>
                      <p className="text-xs text-desti-text mt-1">{r.userEmail || ''}</p>
                      <div className="flex gap-0.5 mt-1">
                        {[1, 2, 3, 4, 5].map(s => (
                          <Star
                            key={s}
                            size={12}
                            weight="fill"
                            className={s <= r.rating ? 'text-desti-gold' : 'text-white/20'}
                          />
                        ))}
                      </div>
                    </div>
                    <span className={`text-xs px-2 py-1 ${r.isApproved ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                      {r.isApproved ? 'Approuve' : 'En attente'}
                    </span>
                  </div>
                  <p className="text-sm text-white/70 leading-relaxed">{r.comment}</p>
                  <p className="text-xs text-white/20 mt-2">{new Date(r.createdAt).toLocaleDateString('fr-FR')}</p>
                  <div className="flex gap-2 mt-3">
                    {!r.isApproved && (
                      <button
                        onClick={() => moderate(r.id, true)}
                        className="flex items-center gap-1 text-xs px-3 py-1 bg-green-500/10 text-green-400 border border-green-500/20 hover:bg-green-500/20 transition-colors"
                        data-testid={`approve-review-${r.id}`}
                      >
                        <Check size={12} /> Approuver
                      </button>
                    )}
                    {r.isApproved && (
                      <button
                        onClick={() => moderate(r.id, false)}
                        className="flex items-center gap-1 text-xs px-3 py-1 bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20 transition-colors"
                        data-testid={`reject-review-${r.id}`}
                      >
                        <X size={12} /> Rejeter
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
